import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { ChangeLogEffect } from "./effect";
import { ChangeLogReducer } from "./reducer";

@NgModule({
  imports: [EffectsModule.forFeature([ChangeLogEffect]), StoreModule.forFeature("changeLog", ChangeLogReducer)]
})
export class ChangeLogStoreModule {}

export const changeLog = (store: any) => store && store.changeLog && store.changeLog.changeLog;
export const downloadChangeLogCsvResponse = (store: any) => store && store.changeLog && store.changeLog.downloadChangeLogCsvResponse;
